"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const CardStyles_1 = require("../card/CardStyles");
require("./CannotCheckout.scss");
const defaultMessageError = 'Você só poderá realizar check-out quando estiver em uma data válida e não tiver realizado check-out anteriormente!';
const statusPaymentMessageError = 'Você só poderá realizar o check-out quando seu pagamento for aprovado.';
const STATUS_APPROVED = 'APPROVED';
const CannotCheckout = props => {
    const { statusPayment: status } = props;
    return (react_1.default.createElement("div", { className: "Instruction-Checkout-Container" },
        react_1.default.createElement("div", { className: "instructions-title" },
            react_1.default.createElement(CardStyles_1.Title, null, "Check-out")),
        react_1.default.createElement("div", { className: "instructions-fields" },
            react_1.default.createElement("span", null, status !== STATUS_APPROVED ? statusPaymentMessageError : defaultMessageError))));
};
exports.default = CannotCheckout;
